module.exports = __webpack_public_path__ + "static/media/441971837_460386656809044_1243932719771294797_n.f7c0fdde.jpg";